import React, { ComponentClass, FunctionComponent } from 'react';

import { ChartIcon, ContractIcon, DoorClosingIcon, WrenchIcon } from '../../components/icons';
import APIKeys from './APIKeys';
import Docs from './Docs';
import Usage from './Usage';
import Webhooks from './Webhooks';

export interface ITabConfig {
  icon: React.ReactNode;
  link: string;
  name: string;
  path: string;
  component: ComponentClass | FunctionComponent;
  isDisabled?: boolean;
}

// Canonical list of tabs and routes. First tab here will automatically be the landing tab.
export const tabs: Array<ITabConfig> = [
  {
    icon: <DoorClosingIcon />,
    link: '/keys',
    name: 'API Keys',
    path: 'keys',
    component: APIKeys,
  },
  {
    icon: <WrenchIcon />,
    link: '/webhooks',
    name: 'Webhooks',
    path: 'webhooks',
    component: Webhooks,
  },
  {
    icon: <ChartIcon />,
    link: '/usage',
    name: 'Usage Logs',
    path: 'usage',
    component: Usage,
  },
  {
    icon: <ContractIcon />,
    link: '/documentation',
    name: 'Documentation',
    path: 'documentation',
    component: Docs,
  },
];
